import { Typography } from '@cp/ds/src/components/typography';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { MapWithLinksRegionsCityRenderer } from './types';

export const defaultCityRenderer: MapWithLinksRegionsCityRenderer = (city) => {
  return (
    <StyledListItem
      sx={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        py: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Link href={city.routeName} underline={false}>
        <Typography sx={{ color: 'gray' }} variant="body">
          {city.cityName}
        </Typography>
      </Link>
    </StyledListItem>
  );
};
